{
    "help": {
        "button": { "tooltip": "Hjelp" },
        "title": "Hjelpeassistent",
        "reconnecting": "Kobler til på nytt…",
        "thinking": "Tenker…",
        "noMessagesYet": "Hei! Jeg er VinceLive-hjelpeassistenten din.\nSpør meg om hva som helst om hvordan VinceLive fungerer — funksjoner, arbeidsflyter eller hvor du finner det du trenger — så viser jeg deg til de rette svarene og dokumentene.",
        "typeYourMessage": "Skriv meldingen din…",
        "collapse": "Lukk",
        "displayMode": {
            "dock": "Fest som sidepanel",
            "float": "Vis over innholdet"
        },
        "choice": { "placeholder": "Velg et alternativ", "confirm": "Bekreft" },
        "reader": {
            "back": "Tilbake",
            "fullscreen": "Fullskjerm",
            "exitFullscreen": "Avslutt fullskjerm",
            "close": "Lukk",
            "openInApp": "Åpne i appen",
            "loading": "Laster…",
            "error": "Kunne ikke laste dette dokumentet.",
            "retry": "Prøv igjen"
        },
        "context": {
            "title": "Juster svar",
            "optionsError": "Kunne ikke laste bransje- og avdelingsvalg.",
            "industry": "Bransje",
            "department": "Team",
            "notSet": "Ikke angitt",
            "answers": "Svar",
            "thisConversation": "Denne samtalen",
            "aboutYou": "Om deg",
            "aboutYouHint": "Settes én gang. Brukes til å velge eksempler og begreper.",
            "level": "Ditt ferdighetsnivå",
            "length": "Svarlengde",
            "done": "Ferdig",
            "appliesNext": "Gjelder fra neste spørsmål"
        },
        "notice": {
            "busy": "Hjelpen er opptatt. Prøver igjen…",
            "paused": "Samtalen er satt på pause. Trykk for å fortsette.",
            "badFrame": "Tilkoblingsfeil. Kobler til på nytt…",
            "connectFailed": "Kunne ikke starte Hjelp. Prøv igjen.",
            "resume": "Fortsett",
            "retry": "Prøv igjen",
            "turnInterrupted": "Den siste meldingen din kom kanskje ikke fram – send den på nytt."
        },
        "level": {
            "beginner": "Nybegynner",
            "beginnerHint": "Forutsetter ingen erfaring med VinceLive",
            "intermediate": "Middels",
            "intermediateHint": "Hopper over det grunnleggende",
            "advanced": "Avansert",
            "advancedHint": "Rett til innstillingen",
            "expert": "Ekspert",
            "expertHint": "Kort, uten gjennomgang"
        },
        "length": {
            "brief": "Kort",
            "full": "Fullstendig"
        },
        "send": "Send"
    },
    "ai": {
        "usage": {
            "emptyState": "Ingen bruk er registrert ennå.",
            "totalTokens": "Totale tokens",
            "estimatedCost": "Estimert kostnad",
            "sessions": "Økter",
            "inputTokens": "Inn-tokens",
            "outputTokens": "Ut-tokens",
            "cacheCreationTokens": "Tokens for cache-skriving",
            "cacheReadTokens": "Tokens for cache-lesing",
            "tokenBreakdown": "Tokenfordeling",
            "fundingBreakdown": "Kostnadsfordeling",
            "yourConnection": "Din tilkobling",
            "estimateDisclaimer": "Token-tall er nøyaktige. Beløp i dollar er estimater og kan avvike fra faktisk fakturering.",
            "vinceAi": "Vince AI",
            "estimateHint": "Løpende total for denne byggeøkten. Dollarbeløpet er et estimat.",
            "tokensValue": "{value} tokens",
            "estimateSuffix": "(est.)",
            "noUsageRecorded": "Ingen bruk er registrert for denne økten.",
            "vinceProvided": "Levert av Vince",
            "unknownConnection": "Ukjent tilkobling",
            "byConnection": "Etter tilkobling",
            "sessionsCount": "{count} økter",
            "unpricedUsage": "Noe bruk kunne ikke prises",
            "permissionDenied": "Du har ikke tilgang til å se denne bruken.",
            "loadError": "Bruken kunne ikke lastes. Prøv på nytt.",
            "exactHint": "Løpende total for denne byggeøkten. Dollarbeløpet er nøyaktig.",
            "billedCost": "Fakturert kostnad",
            "legacyEstimate": "Estimert total inkludert tidligere bruk: {value}",
            "billedExcludesHistory": "Ekskluderer tidligere bruk registrert før nøyaktig prising.",
            "exactDisclaimer": "Token-tall og dollarbeløp er nøyaktige som fakturert."
        }
    },
    "foundation": {
        "resource": {
            "apiclient": "API-klient",
            "connection": "Tilkobling",
            "dashboard": "Dashbord",
            "environment": "Miljø",
            "user": "Bruker",
            "workflow": "Arbeidsflyt",
            "group": "Gruppe",
            "variable": "Variabel",
            "webhook": "Webhook",
            "metadata": "Metadata",
            "role": "Rolle",
            "gateway": "Gateway"
        }
    },
    "core": {
        "app": {
            "ai-apps": "AI-apper",
            "customtables": "Egendefinerte tabeller",
            "fnd": "Grunnlag",
            "tenantManagement": "Leietakerledelse"
        }
    },
    "addon": {
        "app": {
            "kanban": "Kanban",
            "campaign": "Kampanje",
            "impexHelper": "Impex-hjelper",
            "mdbreadmiHelper": "MDB Readmi-hjelper",
            "miTest": "MI-test",
            "m3PrintoutConfig": "M3-utskriftskonfigurasjon",
            "vincePricer": "Vince Pricer",
            "cugexHelper": "CUGEX-hjelper",
            "isLantmannen": "Er Lantmännen",
            "spykar": "Spykar",
            "eshopbox": "Eshopbox",
            "scannerPickPack": "Skanner Pick Pack",
            "pickPack": "Pick Pack",
            "contractManagement": "Kontraktsstyring",
            "aiApps": "AI-apper",
            "aiWorkflows": "AI-arbeidsflyter"
        },
        "resource": {
            "aiWorkflow": "Arbeidsflyt"
        }
    },
    "fileSelector": {
        "microsoftThrottled": "Microsoft har midlertidig begrenset SharePoint-forespørsler. Vent litt og prøv på nytt.",
        "sitesLoadFailed": "Kunne ikke laste SharePoint-nettsteder.",
        "itemsLoadFailed": "Kunne ikke laste SharePoint-filer.",
        "retry": "Prøv på nytt"
    },
    "wildcard": {
        "option": "Alle",
        "fullAccess": "Full tilgang"
    },
    "action": {
        "read": "Lese",
        "write": "Skrive"
    },
    "customTable": {
        "resource": {
            "configuration": "Konfigurasjon",
            "data": "Data"
        }
    },
    "common": {
        "logicalOperators": {
            "AND": "OG",
            "OR": "ELLER"
        },
        "actions": {
            "advanced": "Avanserte innstillinger",
            "apply": "Bruk",
            "back": "Tilbake",
            "cancel": "Avbryt",
            "clear": "Tøm",
            "close": "Lukk",
            "copy": "Kopier",
            "create": "Opprett",
            "yesDelete": "Ja, slett",
            "delete": "Slett",
            "edit": "Rediger",
            "next": "Neste",
            "no": "Nei",
            "ok": "Ok",
            "previous": "Forrige",
            "reset": "Tilbakestill",
            "save": "Lagre",
            "update": "Oppdater",
            "view": "Vis",
            "yes": "Ja",
            "activate": "Aktiver",
            "deactivate": "Deaktiver",
            "goHomePage": "Gå tilbake til startsiden",
            "add": "Legge til",
            "execute": "Henrette",
			"selectAll": "Velg alle",
			"showSelected": "Vis valgte"
        },
        "system": "System",
        "label": "Etikett",
        "labels": "Etiketter",
        "actionsLabel": "Handlinger",
        "noPermission": "Ingen tilgang",
        "active": "Aktiv",
        "activated": "Aktivert",
        "deactivated": "Deaktivert",
        "address": "Adresse",
        "alias": "Alias",
        "confirmation": "Bekreftelse",
        "description": "Beskrivelse",
        "details": "Detaljer",
        "download": "Last ned",
        "email": "E-post",
        "tenantPermissions": "Leietakertillatelser",
        "firstName": "Fornavn",
        "surname": "Etternavn",
        "fullName": "Fullt navn",
        "in": "i",
        "lastName": "Etternavn",
        "left": "Venstre",
        "loading": "Lasting",
        "milliseconds": "ms.",
        "name": "Navn",
        "notFound": "Ikke funnet",
        "notFoundAbbreviation": "IF",
        "of": "av",
        "operation": {
            "EqualTo": "Lik",
            "GreaterThan": "Større enn",
            "GreaterThanEqualTo": "Større enn eller lik",
            "LessThan": "Mindre enn",
            "LessThanEqualTo": "Mindre enn eller lik",
            "NotEqualTo": "Ikke lik"
        },
        "password": "Passord",
        "permissions": "Tillatelser",
        "phone": "Telefon",
        "primary": "PRIMÆR",
        "right": "Høyre",
        "roles": "Roller",
        "noRoles": "Ingen roller tildelt",
        "search": "Søk",
        "searchPlaceholder": "Skriv for å søke",
        "texts": {
            "item": "punkt",
            "selected": "calgt",
            "select": "Velge"
        },
        "tags": "Etiketter",
        "success": "Vellykket",
        "assignRolesToUser": "Legg til denne brukeren i roller",
        "assignTagsToUser": "Tildel tagger til denne brukeren"
    },
    "comparison": {
        "equal": "Lik (=)",
        "greaterThan": "Større enn (>)",
        "greaterThanInclusive": "Større enn eller lik (>=)",
        "isBlank": "Er tom (=)",
        "isNotBlank": "Er ikke tom (!=)",
        "lessThan": "Mindre enn (<)",
        "lessThanInclusive": "Mindre enn eller lik (<=)",
        "notEqual": "Ikke lik (!=)",
        "stringContains": "Teksten inneholder",
        "stringNotContains": "Teksten inneholder ikke"
    },
    "dataTypes": {
        "DATE": "Dato",
        "NUMERIC": "Nummer",
        "STRING": "Tekst",
        "BOOLEAN": "Boolsk"
    },
    "environments": {
        "code": "Miljø-ID i VXL Live",
        "deleteConfirmation": "Vil du slette {environmentName}?",
        "descriptionRequired": "Miljøbeskrivelse er påkrevd",
        "environmentActions": {
            "deleteEnvironment": {
                "title": "Bekreft sletting"
            }
        },
        "idRequired": "Miljø-ID er påkrevd",
        "messages": {
            "deleteSuccess": "Miljøet ble slettet!",
            "cannotDeleteEnvironmentInConnection": "Kan ikke slettes, miljøet finnes i en tilkobling",
            "codeFormat": "Koden godtar 1-4 bokstaver (A-Å). Eksempel: TEST, PROD",
            "environmentNameExists": "Miljøet {environmentName} eksisterer allerede!",
            "errorOccurred": "Det oppstod en feil",
            "success": "Miljø lagret vellykket!"
        },
        "nameRequired": "Miljønavn er påkrevd",
        "newEnvironment": "Nytt miljø",
        "selectColor": "Velg en farge",
        "theme": "Tema",
        "title": "Miljøer"
    },
    "connections": {
        "port": "Havn",
		"m3Name": "M3 navn",
		"clientId": "Klient-ID",
		"clientSecret": "Klienthemmelighet",
		"autofillDetails": "Autofyll fra fil",
		"uploadFile": "Last opp fil",
        "authenticationType": "Autentiseringstype",
        "accessKey": "Tilgangsnøkkel",
        "authHeaderName": "Navn på autorisasjonsheader",
        "messages": {
            "confirmDeleteHeader": "Slett tilkobling",
            "confirmDeleteMessage": "Er du sikker på at du vil slette denne tilkoblingen?",
            "confirmCertificateIssueHeader": "Utsted sertifikat",
            "confirmCertificateIssueMessage": "Er du sikker på at du vil utstede sertifikatet for denne tilkoblingen?",
            "confirmCertificateRevokeHeader": "Tilbakekall sertifikat",
            "confirmCertificateRevokeMessage": "Er du sikker på at du vil tilbakekalle sertifikatet for denne tilkoblingen?",
            "saveSuccess": "Tilkoblingen er lagret",
            "deleteSuccess": "Tilkoblingen ble slettet",
            "validateSuccess": "Tilkoblingen er validert",
            "certificateIssueSuccess": "Sertifikat utstedt vellykket",
            "mandatoryField": "Dette feltet er obligatorisk",
            "cannotDelete": "Denne tilkoblingen kan ikke slettes da den er koblet til én eller flere arbeidsflyter",
            "importApiErrorMessage": "Kunne ikke importere API-er.",
            "bulkImportApiError": "Kunne ikke starte masseimport av API-er.",
            "loadApiProgramsError": "Kunne ikke laste API-programmer for denne tilkoblingen.",
            "loadConnectionForImportError": "Kunne ikke laste den valgte tilkoblingen.",
            "errorWithReason": "{message} Årsak: {reason}",
            "environmentAlreadyConnectedError": "En forbindelse med typen {system} finnes allerede i {environment}-miljøet!",
            "certificateIgnoredMessage": "Hvis «Bruk proxy» er aktivert, vil sertifikatet bli ignorert.",
            "certificate": "Sertifikat"
        },
        "certificate": {
			"title": "MTLS-sertifikat",
			"VinceLiveCertificate": "Bruk Vince Live-sertifikat",
			"CustomCertificate": "Bruk tilpasset sertifikat",
			"label": "Sertifikat",
			"privateKey": "Privat nøkkel",
			"VLCertificatePlaceholder": "Sertifikat fra Vince Live",
			"CustomCertificatePlaceholder": "Skriv inn sertifikat eller last opp fil nedenfor",
			"CustomPrivateKeyPlaceholder": "Skriv inn privat nøkkel eller last opp fil nedenfor",
			"fileWarningMessage": "Filen må være i OpenSSL-format",
			"changePrivateKey": "Endre privat nøkkelfil",
			"changeCertificate": "Endre sertifikatfil",
			"privateKeyLoaded": "✓ Privat nøkkel lastet inn ({length} tegn)",
			"certificateLoaded": "✓ Sertifikat lastet inn ({length} tegn)"
		},
        "connectivity": "Tilkobling",
        "security": "Sikkerhet",
        "details": "Detaljer"
    },
    "notifications": {
		"noNotifications": "Ingen nye varsler",
		"announcement": "Kunngjøring",
		"title": "Varsler",
        "clearAll": "Fjern alle",
        "workflowSuccessful": "Arbeidsflyt kjøring vellykket",
        "workflowFailed": "Arbeidsflyt mislyktes",
		"acknowledge": "Bekreft varsling",
		"customTables": {
			"header": "Tabellindekseringsfeil",
			"indexError": "Indeksering mislyktes for tabell \"{tableName}\"",
			"toastSummary": "Tabellindekseringsfeil",
			"toastDetailWithReason": "Tabell: \"{tableName}\"\nNøkler: {keys}\n\nÅrsak: {reason}",
			"toastDetail": "Tabell: \"{tableName}\"\nNøkler: {keys}\n\nIndeksering mislyktes",
			"viewTable": "Vis tabell",
			"unknownError": "Ukjent feil"
		}
	},
    "header": {
        "apiClients": "API-klienter",
        "roles": "Roller",
        "users": "Brukere",
        "tenants": "Leietakere"
    },
    "home": {
        "greeting": {
            "morning": "God morgen",
            "afternoon": "God ettermiddag",
            "evening": "God kveld"
        },
        "tenantLabel": "Leietaker:",
        "welcomeMessage": "Velkommen til Vince-plattformen.\nOpprett, automatiser og administrer arbeidet ditt på ett sted — fra å bygge apper og arbeidsflyter til å strukturere data i tabeller og håndtere administrasjon med trygghet. Love from Vince Team 🧡\nHvis du savner den gamle versjonen, kan du få tilgang til den i en begrenset periode ved å bruke https://{tenantAlias}.old.vince.live",
        "logoAlt": "Vince-logo",
        "cards": {
            "feedback": {
                "title": "Gi oss tilbakemelding",
                "content": "Vi vil høre fra deg!\nDin tilbakemelding former fremtiden til Vince. Fant du en feil? Har du en god idé? Vil du fortelle oss hva som fungerer, eller ikke fungerer? Gi oss beskjed!",
                "buttonLabel": "Gi oss tilbakemelding"
            },
            "documentation": {
                "title": "Dokumentasjon",
                "content": "Alt du trenger – samlet på ett sted.\nEnten du er ny i Vince eller en erfaren bruker, er dokumentasjonen vår her for å hjelpe. Bla gjennom veiledninger, funksjonsguider, oppsettstips og mer.\n\nDykk ned i kunnskapsbasen.",
                "buttonLabel": "Dokumentasjon"
            },
            "releaseNotes": {
                "title": "Versjonsnotater",
                "content": "Hold deg oppdatert på de nyeste funksjonene, forbedringene og feilrettingene. Vi holder versjonsnotatene enkle og oversiktlige – så du kan bruke mer tid på å bygge og mindre på å lese.\nVi leverer regelmessig nye funksjoner, forbedringer og feilrettelser.\n\nSjekk hele endringsloggen.",
                "buttonLabel": "Se versjonsnotater"
            },
            "news": {
                "title": "Nyheter fra Vince",
                "content": "Hva skjer hos Vince?\nHold deg oppdatert med produktnyheter, innsikt bak kulissene og tips fra teamet vårt. Vi bygger i det åpne – og du er invitert.\n\nFå med deg høydepunktene.",
                "buttonLabel": "Besøk Vince"
            }
        }
    },
    "menus": {
        "administration": "Administrasjon",
        "home": "Hjem",
        "info": "Informasjon",
        "apps": "Apper",
        "settings": "Innstillinger",
        "accessManagement": "Tilgangsstyring",
        "reports": "Rapporter",
		"aiSettings": "AI-innstillinger",
		"workflowSettings": "Arbeidsflytinnstillinger",
		"workflowManagement": "Arbeidsflytadministrasjon",
		"external": "Hjelp og ressurser",
		"integrations": "Integrasjoner",
        "subMenus": {
            "users": "Brukere",
			"roles": "Roller",
			"apiClients": "API-klienter",
            "tenants": "Leietakere",
            "accessManagement": "Tilgangsstyring",
            "auditLog": "Revisjonslogg",
            "companySettings": "Firmainnstillinger",
            "connections": "Tilkoblinger",
            "documentation": "Dokumentasjon",
            "environments": "Miljøer",
            "groups": "Grupper",
            "latestUpdates": "Siste oppdateringer",
            "logOut": "Logg ut",
            "schedules": "Tidsplaner",
            "support": "Støtte",
            "tableManagement": "Tabelladministrasjon",
            "userProfile": "Min profil",
            "variables": "Variabler",
            "webhooks": "Webhooks",
            "workflowStatistics": "Arbeidsflytstatistikk",
            "addConnection": "Legg til tilkobling",
            "editConnection": "Rediger tilkobling",
			"newConnection": "Ny tilkobling",
			"manageEnvironments": "Administrer miljøer",
            "apps": {
                "clickAndCollect": "Klikk og hent",
                "campaign": "Kampanje",
                "impexHelper": "Impex-hjelper",
                "mdbreadHelper": "MDBread-hjelper",
                "miTest": "MI-test",
                "m3PrintoutConfig": "M3-utskriftskonfigurasjon",
                "vincePricer": "Vince-prissetter",
                "cugexHelper": "CUGEX-hjelper",
                "lantmannenMaskin": "Lantmännen Maskin",
                "spykarChannelPlan": "Spykar kanalplan",
                "eshopbox": "Eshopbox",
                "scannerPickPack": "Skanner plukk og pakk",
                "pickPack": "Plukk og pakk",
                "contractManagement": "Kontraktsadministrasjon"
            }
        },
        "workflows": "Arbeidsflyter"
    },
    "profile": {
        "dateFormat": "Datoformat",
        "defaultDashboard": "Standard dashbord",
        "languagePreference": "Språkpreferanse",
        "messages": {
            "error": "Kunne ikke lagre preferanser!",
            "success": "Preferanser lagret vellykket!",
            "nameUpdatedSuccess": "Navn oppdatering vellykket!"
        },
        "numberPerPage": "Antall rader i tabeller",
        "preferences": "Preferanser",
        "timeFormat": "Tidsformat",
        "userProfile": "Profilinnstillinger",
        "cookieConsent": {
            "title": "Cookie samtykke",
            "necessary": "Nødvendige",
            "statistics": "Statistikk",
            "description1": "Noen av våre informasjonskapsler er nødvendige for at applikasjonen skal fungere og kan ikke slås av i våre systemer. De settes vanligvis som svar på handlinger du gjør, som å logge inn, fylle ut skjemaer eller angi personverninnstillingene dine.",
            "description2": "For å lage løsninger for en applikasjon som er så brukervennlig som mulig, bruker vi analyseverktøyet Posthog. Med hjelp av Posthog kan vi samle inn data og analysere hvordan Vince-apper og tjenester brukes.",
            "infoTitle": "Hvilken informasjon lagres?",
            "description3": "Posthog mottar generell nett- og appstatistikk. Ingen av dette kan brukes til å identifisere brukerne. Vince bruker kun informasjonskapsler til analytiske formål for å utvikle våre produkter for bedre å imøtekomme brukernes behov, og ikke til markedsføringsformål."
        },
        "privacyPolicy": {
            "title": "Personvernerklæring",
            "customerPortal": "Kundeportal",
            "sections": [
                {
                "title": "1. Hvem vi er",
                "content": "Denne personvernerklæringen gjelder Vince Live-plattformen (\"Vince Live\") og VXL Live Excel-tillegget (\"Tillegget\") for Microsoft 365 (samlet kalt \"Tjenesten\").\nTjenesten drives av Vince AS (Org.nr. 896 890 042), et selskap registrert i Norge med hovedkontor i Riddervolds gate 4, 0256 Oslo, Norge.\nNettsiden vår er {website}.\nVi er behandlingsansvarlig for personopplysninger knyttet til kontoer og tjenesten, og databehandler for personopplysninger som kundeorganisasjoner behandler gjennom arbeidsflyter på plattformen vår.\nFor spørsmål eller forespørsler om personvern kan du kontakte oss via vår {customerPortal} eller på e-post til {email}. Dersom det er aktuelt, kan du også kontakte vårt personvernombud (DPO) gjennom samme portal."
                },
                {
                "title": "2. Roller i behandlingen",
                "content": "Når vi leverer tjenestene, er vi behandlingsansvarlig for konto-, autentiserings-, logg- og analysedata.\nFor arbeidsflytdata er vi databehandler og behandler personopplysninger kun etter instruks fra kundeorganisasjonene, som er ansvarlige for å gi nødvendig informasjon og sikre behandlingsgrunnlag.\nBehandling av personopplysninger på vegne av kundeorganisasjoner reguleres av våre Vilkår og betingelser og Databehandleravtale (DPA). Denne personvernerklæringen gjelder kun behandling hvor vi er behandlingsansvarlig."
                },
                {
                "title": "3. Kategorier av personopplysninger vi behandler (som behandlingsansvarlig)",
                "content": "Vi behandler følgende kategorier av personopplysninger:",
                "items": [
                    "Kontodata: navn, e-postadresse, organisasjonstilhørighet og rolle",
                    "Autentiseringsdata: legitimasjon, token og MFA-metoder",
                    "Identitetsdata fra Microsoft Entra ID: unike identifikatorer og profildata mottatt når du logger inn med Microsoft jobb- eller skolekonto",
                    "Tekniske data: IP-adresse, enhets- eller nettleserinformasjon og øktidentifikatorer",
                    "Tjenestelogger: systemlogger, feillogger og revisjons-/aktivitetslogger (også synlige for kundeadministratorer)",
                    "Kommunikasjonsdata: kontaktinformasjon brukt til driftsmeldinger",
                    "Analysedata (valgfritt samtykke): bruksstatistikk og feilrapporter"
                ],
                "footer": "Faktureringsdata behandles separat gjennom kontrakt og ikke via plattformen.\nVi selger eller leier ikke ut personopplysninger. De deles kun med databehandlere beskrevet i denne erklæringen eller når loven krever det."
                },
                {
                "title": "4. Formål og behandlingsgrunnlag (som behandlingsansvarlig)",
                "content": "Vi behandler personopplysninger kun når det finnes et lovlig behandlingsgrunnlag etter GDPR:",
                "items": [
                    "Oppfyllelse av kontrakt - administrasjon av brukerkontoer, autentisering av brukere, drift av Tjenestene og nødvendige aktivitetslogger",
                    "Berettiget interesse - overvåking av tjenester, driftsmeldinger og sikkerhet",
                    "Samtykke - analyse (valgfritt; for analyse av ytelse og brukervennlighet, uten Kundedata)",
                    "Rettslig forpliktelse - overholdelse av lovpålagte krav"
                ]
                },
                {
                "title": "5. Arbeidsflytdata (databehandlerrollen)",
                "content": "Kundeorganisasjoner kan konfigurere arbeidsflyter som inneholder personopplysninger. I slike tilfeller er kunden behandlingsansvarlig, og vi opptrer kun som databehandler. Vi behandler arbeidsflytdata kun i den grad det er nødvendig for å levere, sikre eller støtte tjenestene."
                },
                {
                "title": "6. Databehandlere",
                "content": "Vi benytter GDPR-kompatible databehandlere, alle lokalisert i EU/EØS:",
                "items": [
                    "Amazon Web Services (AWS) - hosting og infrastruktur",
                    "Twilio / SendGrid - SMS- og e-postlevering",
                    "PostHog - analyse (valgfritt)",
                    "Sentry - feilsporing"
                ]
                },
                {
                "title": "7. Rettigheter for registrerte (som behandlingsansvarlig)",
                "content": "Du har rettighetene som følger av GDPR artikkel 15-22, inkludert innsyn, retting, sletting, begrensning, dataportabilitet, innsigelse og tilbaketrekking av samtykke.\nDu har også rett til å klage til Datatilsynet etter GDPR artikkel 77. Informasjon om hvordan du kontakter Datatilsynet finner du på {datatilsynet}.\nSelvbetjeningsverktøy er tilgjengelige i plattformen, eller du kan sende en forespørsel via vår {customerPortal} eller på e-post til {email}. For arbeidsflytdata hvor vi er databehandler, skal forespørsler rettes til den aktuelle kundeorganisasjonen."
                },
                {
                "title": "8. Lagring og sletting",
                "content": "Personopplysninger lagres kun så lenge det er nødvendig for å levere tjenesten. Logger og aktivitetsdata oppbevares i opptil 90 dager. Etter at en konto avsluttes, slettes personopplysningene innen 90 dager, med mindre lengre lagring er påkrevd ved lov."
                },
                {
                "title": "9. Sikkerhet",
                "content": "Vi benytter tekniske og organisatoriske tiltak som kryptering av data under overføring og lagring, strenge tilgangskontroller og sikker hosting i EU/EØS."
                },
                {
                "title": "10. Internasjonale overføringer",
                "content": "All hosting og databehandling skjer innenfor EU/EØS. Ingen internasjonale overføringer av personopplysninger finner sted."
                },
                {
                "title": "11. Endringer",
                "content": "Vi kan oppdatere denne erklæringen fra tid til annen. Vesentlige endringer vil bli kommunisert via plattformen eller e-post."
                },
                {
                "title": "12. VXL Live Excel-tillegget",
                "content": "Denne delen beskriver hvordan personopplysninger behandles når du bruker VXL Live Excel-tillegget for Microsoft 365 (\"Tillegget\").",
                "items": [
                    "Tillegget har kun tillatelser til å lese og skrive i den gjeldende arbeidsboken. Det har ikke tilgang til andre filer, e-postbokser eller tjenester.",
                    "Data i arbeidsboken som sendes til Vince Live som en del av en arbeidsflyt (og som kan inneholde personopplysninger), behandles som Arbeidsflytdata etter seksjon 5.",
                    "Tillegget bruker ikke innholdet i arbeidsboken til annonsering eller profilering, og selger eller leier ikke ut personopplysninger."
                ]
                },
                {
                "title": "13. Kontakt",
                "content": "Vince AS\nOrg.nr. 896 890 042\nRiddervolds gate 4, 0256 Oslo, Norge\n{website}\n{customerPortal}\nSist oppdatert: November 2025"
                }
            ]
        },
        "tableAndDataFormatting": "Tabell og dataformatering"
    },
    "security": {
        "accessManagement": "Tilgangsstyring",
        "forbidden": "Forbudt",
        "youDontHavePermission": "Du har ikke tillatelse til å få tilgang til denne ressursen. Kontakt din leietakeradministrator angående dine tillatelser.",
        "apiClients": {
            "activateApiClients": "Vil du aktivere API-klienten?",
            "active": "Aktiv",
            "addApiClients": "Legg til API-klienter",
            "apiClient": "API-klient",
            "apiClientName": "API-klientnavn",
            "createApiClients": "Opprett API-klienter",
            "deactivateApiClients": "Vil du deaktivere API-klienten?",
            "description": "Beskrivelse",
            "loadingApiClients": "Laster API-klienter...",
            "name": "Navn",
            "updatingApiClientsRoles": "Oppdaterer API-klientroller..."
        },
        "roles": {
            "header": "Roller",
            "addRole": "Legg til rolle",
            "roleName": "Rollenavn",
            "placeholder": "Velg roller",
            "newRole": "Ny rolle",
            "inactive": "Inaktiv",
            "active": "Aktiv",
            "numberOfUsers": "Antall brukere",
            "numberOfPermissions": "Antall tillatelser",
            "externalId": "Ekstern ID",
            "externalIdPlaceholder": "IdP-gruppe-ID (f.eks. Microsoft Entra-gruppeobjekt-ID)",
            "externalIdHint": "Knytt denne rollen til en gruppe hos identitetsleverandøren for SCIM-provisjonering.",
            "table": {
                "app": "App",
                "resource": "Ressurs",
                "resourceName": "Ressursnavn",
                "addPermissions": "Legg til tillatelser",
                "selectApp": "Velg app",
                "selectResource": "Velg ressurs",
                "selectResourceName": "Velg ressursnavn",
                "selectPermission": "Velg tillatelse",
                "permission": "Tillatelse",
                "resourceNameNotAvailable": "Navnet på denne ressursen var ikke tilgjengelig."
            },
            "messages": {
                "nameRequired": "Rollenavn er påkrevd.",
                "descriptionRequired": "Beskrivelse er påkrevd.",
                "appRequired": "Applikasjon er påkrevd.",
                "resourceRequired": "Ressurs er påkrevd.",
                "resourceNameRequired": "Ressursnavn er påkrevd.",
                "actionRequired": "Handling er påkrevd.",
                "success": "Rollen ble lagret.",
                "deleteRoleConfirmation": "Er du sikker på at du vil slette rollen {roleName}?",
                "deleteRoleSuccess": "Rollen ble slettet.",
                "activateSuccess": "Rollen ble aktivert!",
                "deactivateSuccess": "Rollen ble deaktivert!"
            }
        },
        "users": {
            "addUser": "Legg til bruker",
            "lastActive": "Sist aktiv",
            "manageUser": "Administrer bruker",
            "deactivateUser": "Deaktiver bruker",
            "deactivateUserConfirm": "Vil du deaktivere denne brukeren?",
			"deactivateSuccessMessage": "Brukeren har blitt deaktivert",
			"activateUser": "Aktiver bruker",
			"activateUserConfirm": "Vil du aktivere denne brukeren?",
			"activateSuccessMessage": "Brukeren har blitt aktivert",
			"resendInvite": "Send invitasjon på nytt",
			"resendInviteSuccessMessage": "Invitasjonen er sendt til brukeren",
            "permissions": {
                "VINCE_LIVE_ADMIN": "Live Admin",
                "VINCE_LIVE_USER": "Live Bruker",
                "TENANT_ADMIN": "Admin",
                "TENANT_USER": "Bruker"
            },
            "activeUsers": "{used}/{total} aktive brukere på din leieplan.",
            "abovePlan": "Du er over planen din, kostnader vil bli lagt til per bruker.",
            "upgradePlanLink": "Oppgrader planen din"

        }
    },
    "signIn": {
        "backToSignIn": "Tilbake til innlogging",
        "forgotPassword": "Glemt passord?",
        "forgotPasswordInstruction": "Du vil motta en e-post og en kode for å tilbakestille passordet ditt.",
        "invalidPassword": "! Feil passord",
        "login": "Logg inn",
        "loginMicrosoft": "Logg inn med Microsoft",
        "loginOkta": "Logg inn med Okta",
        "preparingVince": "Forbereder din Vince-opplevelse...",
        "resetPassword": "Tilbakestill passord",
        "signinTo": "Logg inn på {tenant}",
        "userNotFound": "! Oi, e-posten ble ikke funnet. Skriv inn en registrert e-postadresse eller kontakt support",
        "confirmationCodeRequired": "Bekreftelseskode kreves",
		"passwordCriteriaMismatch": "! Passordet samsvarer ikke med kriteriene",
		"invalidConfirmationCode": "Ugyldig bekreftelseskode oppgitt. Prøv på nytt.",
		"attemptLimitExceeded": "Forsøksgrensen er overskredet. Prøv senere.",
		"confirmationCode": "Bekreftelseskode",
		"confirmationCodeInstruction": "Bekreftelseskoden er sendt til e-postadressen din.",
		"newPassword": "Nytt passord",
		"newPasswordInstruction": "* Passordet må være minst 8 tegn langt, og det må inneholde minst én stor bokstav, én liten bokstav og et tall",
        "invalidParameter": "Feil ved tilbakestilling av passord. Kontakt kundestøtte for ytterligere hjelp.",
        "enterValidEmail": "Vennligst skriv inn en gyldig e-postadresse.",
        "userDisabled": "Brukeren er deaktivert, vennligst kontakt kundestøtte",
        "selectSsoProvider": "Velg SSO-leverandør",
        "processingSso": "Behandler SSO-pålogging ...",
        "ssoAuthFailed": "Autentiseringen mislyktes. Prøv på nytt.",
        "externalAuthRedirecting": "Omdirigerer...",
        "externalAuthCompleted": "Autentiseringen er fullført. Du kan lukke dette vinduet.",
        "externalAuthFailed": "Autentiseringen mislyktes. Du kan lukke dette vinduet og prøve på nytt."
    },
    "tables": {
        "chooseExcelFile": "Velg fil",
        "columns": "Kolonner",
        "copy": "Kopier tabell",
        "copyPrefix": "Kopi av ",
        "createdBy": "Opprettet av",
        "emptyFilteredText": "Det er ingen poster som samsvarer med forespørselen din.",
        "noEntitiesMessage": "Ingen enheter i denne leietakerens arbeidsområde.",
        "createTable": "Opprett tabell",
        "delete": "Slett tabell",
        "deletingInProgress": "Sletting pågår...",
        "deleteConfirmation": "Er du sikker på at du vil slette tabellen {tableName}?  \nSletteprosessen kan ta opptil 6 timer. \nI løpet av denne tiden vil tabellen forbli i statusen \n\"Sletting pågår...\"",
        "deleteData": "Slett innhold",
        "deleteItem": "Slett tabell",
        "deleteTableSuccess": "Tabell slettet vellykket",
        "dragExcelFiles": "Dra og slipp Excel-filer her for opplasting.",
        "edit": "Rediger tabell",
        "validateConnection": "Bekreft tilkoblingen",
		"importAPIs": "Importer API-er",
		"issueMTLSCert": "Utsted MTLS-sertifikat",
		"editConnection": "Redigere",
		"deleteConnection": "Slett",
        "form": {
            "addColumnButton": "Legg til kolonne",
            "columnAliasNameField": "Aliasnavn",
            "columnNameField": "Kolonnenavn",
            "dataTypeField": "Datatype",
            "linkField": "Lenke",
            "linkTextField": "Lenketekst",
            "primaryKeyField": "Primærnøkkel",
            "validations": {
                "duplicateColumnNamesError": "Dupliserte kolonnenavn funnet: {duplicates}.",
                "emptyColumnNameError": "Kolonnenavn kan ikke være tomt."
            }
        },
        "modifiedBy": "Endret av",
        "new": "Opprett ny tabell",
        "rows": "Rader",
        "showColumnConfig": "Kolonneinformasjon",
        "showData": "Vis data",
        "tableConfig": "Tabellkonfigurasjon",
        "tableName": "Tabellnavn",
        "title": "Tabelladministrasjon",
        "truncateConfirmation": "Er du sikker på at du vil slette alle radene i tabellen {tableName}?",
        "truncateItem": "Tøm tabell",
        "truncateTableSuccess": "Tabellinnhold slettet vellykket",
        "updateType": "Oppdateringstype",
        "updateTypes": {
            "APPEND": "Legg til",
            "REPLACE": "Erstatt",
            "UPSERT": "Oppdater/Legg til"
        },
        "upload": "Last opp Excel",
        "uploadExcel": "Last opp Excel",
        "deleteRowMessage": "Er du sikker på at du vil slette de valgte radene?",
		"deleteRowSuccess": "Valgte rader slettet. Det kan ta litt tid før endringene vises.",
		"deleteRowButtonLabel": "Slett ({selectedRows} rader)",
        "saveSuccess": "Tabellkonfigurasjon lagret."
    },
    "tags": {
        "addTag": "Legg til etikett",
        "duplicateKey": "En etikett med denne nøkkelen finnes allerede",
        "editTag": "Rediger etikett",
        "createTag": "Opprett etikett",
        "placeholder": "Tagger er nøkkelverdipar som brukeren kan knytte til enheter for å filtrere data og kontrollere tilgang i Vince Platform",
		"noTagsApplied": "Ingen tagger er brukt for denne brukeren",
        "confirmRemoveTag": "Er du sikker på at du vil fjerne taggen?",
		"tagName": "Tagnavn",
		"tagValue": "Verdi/Nøkkel",
        "nameOfTag": "Navn på tagg",
		"valueKey": "Verdinøkkel"
    },
    "users": {
        "addRoles": "Legg til roller",
        "addUser": "Legg til bruker",
        "newUser": "Ny bruker",
        "edit": "Rediger",
        "personalInfo": "Personlig informasjon",
        "saveSuccess": "Bruker lagret",
        "saveError": "Feil ved lagring av bruker",
        "userNotFound": "Bruker ikke funnet",
        "loadError": "Feil ved lasting av brukerdata",
        "selectRole": "Velg en rolle",
        "assignRolesToUser": "Legg til denne brukeren i roller",
        "assignTagsToUser": "Tildel tagger til denne brukeren",
        "userFields": {
            "lastActive": "Sist aktiv",
            "m3userId": "M3 Bruker-ID"
        },
        "validation": {
            "keyRequired": "Nøkkel er påkrevd",
            "duplicateTagKey": "Taggnøkkel \"{value}\" finnes allerede",
            "valueEmpty": "Verdi kan ikke være tom",
            "valueRequired": "Minst én verdi er påkrevd",
            "singleValueAllowed": "Bare én verdi er tillatt",
            "firstNameRequired": "Fornavn er påkrevd",
            "firstNameMinLength": "Fornavn må være minst 2 tegn",
            "firstNameMaxLength": "Fornavn må ikke overstige 50 tegn",
            "lastNameRequired": "Etternavn er påkrevd",
            "lastNameMinLength": "Etternavn må være minst 2 tegn",
            "emailRequired": "E-post er påkrevd",
            "emailInvalid": "Vennligst skriv inn en gyldig e-post",
            "emailInUse": "Denne e-posten er allerede i bruk",
            "permissionRequired": "Tillatelse er påkrevd"
        }
    },
    "roles": {
        "addRole": "Legg til rolle",
        "createRole": "Opprett rolle",
        "placeholder": "Roller er noe som gir tillatelser til å vise eller redigere dashbord, arbeidsflyter eller tabeller",
		"noRolesApplied": "Ingen roller er brukt for denne brukeren",
        "confirmRemoveRole": "Er du sikker på at du vil fjerne taggen «{tagName}» fra denne brukeren?",
        "tagName": "Tagnavn",
		"tagValue": "Verdi/Nøkkel"
    },
    "apiClients": {
        "apiClientName": "API-klientnavn",
        "description": "Beskrivelse",
        "active": "Aktiv",
        "action":"Handling",
        "addApiClient": "Legg til API-klient",
        "messages": {
            "deleteAPIClientConfirmation": "Er du sikker på at du vil slette API-klienten '{apiClientName}'?",
            "deleteAPIClientSuccess": "API-klient slettet.",
            "deactivateAPIClientConfirmation": "Vil du deaktivere API-klienten '{apiClientName}'?",
            "apiClientNameRequired": "Klientnavn er obligatorisk",
            "success": "API-klient lagret!",
            "activateSuccess": "API-klienten er aktivert!",
			"deactivateSuccess": "API-klienten er deaktivert!",
			"apiClientNameInvalid": "Navnet kan bare inneholde alfanumeriske tegn, mellomrom og følgende: +=,.@-"
        },
        "name":"Navn",
        "label":"Etikett",
        "roles":"Roller",
        "clientId": "API-klient-ID",
        "clientSecret": "API-klienthemmelighet",
        "newAPIClient": "Ny API-klient",
        "editAPIClient": "Rediger API-klient"
    },
    "webhooks": {
        "activateSuccess": "Webhook aktivert!",
        "deactivateSuccess": "Webhook deaktivert!",
        "description": "Beskrivelse",
        "invalidWorkflow": "Ugyldig arbeidsflyt",
        "messages": {
            "copied": "Kopiert til utklippstavlen",
            "copyError": "Kunne ikke kopiere",
            "deleteWebhookConfirmation": "Er du sikker på at du vil slette webhook {webhookName}?",
            "deleteWebhookSuccess": "Webhook slettet!",
            "success": "Webhook lagret!",
            "webhookNameRequired": "Webhook-navn er påkrevd",
            "workflowRequired": "Arbeidsflyt er påkrevd"
        },
        "newWebhook": "Ny Webhook",
        "title": "Webhooks",
        "webhookDetails": "Webhook-detaljer",
        "webhookId": "Webhook-ID",
        "webhookName": "Webhook-navn",
        "workflow": "Arbeidsflyt",
        "username": "Brukernavn",
        "password": "Passord",
        "token": "Token"
    },
    "variables": {
        "addVariable": "Legg til variabel",
        "editVariable": "Rediger variabel",
        "tooltip": "Variabler er en måte å lagre verdier som kan brukes i arbeidsflyter. Variabler kan være sikre eller usikre. Sikre variabler er kryptert og kan ikke vises i klartekst.",
        "messages": {
            "success": "Variabel lagret!",
            "deleteVaribaleConfirmation": "Er du sikker på at du vil slette variabelen {variableName}?",
            "varibaleNameRequired": "Variabelnavn er påkrevd",
            "varibaleValueRequired": "Variabelverdi er påkrevd",
            "deleteSuccess": "Variabelen ble slettet!"
        },
        "name": "Navn",
        "secure": "Sikker",
        "title": "Variabler",
        "value": "Verdi",
        "newVariable": "Ny variabel",
        "unsecure": "Usikker"
    },
    "company": {
        "headers": {
            "settings": "Firma-innstillinger",
            "identityProviders": "Identitetsleverandører",
            "identityProvidersName": "Navn på identitetsleverandører",
            "enterpriseIntegrations": "Bedriftsintegrasjoner",
            "companyInformation": "Firmainformasjon"
        },
        "tabs": {
            "information": "Informasjon",
            "scim": "Scim",
            "singlesignon": "Single Sign-On"
        },
        "labels": {
            "identityProvider": "Identitetsleverandør",
            "scimUrl": "SCIM-URL",
            "token": "Token",
            "enforceSso": "Håndhev SSO",
            "identityProviderName": "Navn på identitetsleverandør",
            "issuerUrl": "Utsteder-URL",
            "clientId": "Klient-ID",
            "clientSecret": "Klienthemmelighet",
            "companyName": "Firmanavn",
            "tenantId": "Leietaker-ID",
			"dedicatedIpAddresses": "Dedikerte IP-adresser",
			"dedicatedIpWhitelistInfo": "Hvitlist disse IP-adressene for å tillate trafikk fra din dedikerte proxy"
        },
        "placeholders": {
            "selectIdentityProvider": "Velg identitetsleverandør",
            "scimUrl": "SCIM-URL",
            "token": "Token",
            "identityProviderName": "Navn på identitetsleverandør",
            "issuerUrl": "Utsteder-URL",
            "clientId": "Klient-ID",
            "clientSecret": "Klienthemmelighet"
        },
        "buttons": {
            "addIdentityProvider": "Legg til identitetsleverandør",
            "regenerateToken": "Generer token på nytt"
        },
        "messages": {
            "identityProviderDeleted": "Identitetsleverandør slettet.",
            "deleteConfirmation": "Er du sikker på at du vil slette identitetsleverandøren '{providerName}'?",
            "configuringIdentityProvider": "Identitetsleverandøren konfigureres. Dette kan ta litt tid.",
            "updatedIdentityProvider": "Identitetsleverandør oppdatert.",
            "ssoUpdated": "SSO-innstillinger oppdatert.",
            "enforceSsoDisabledTooltip": "Legg til en identitetsleverandør for å aktivere SSO-tvang.",
            "tokenGenerated": "SCIM-token generert.",
            "copied": "Kopiert til utklippstavlen.",
            "copyError": "Kunne ikke kopiere til utklippstavlen."
        },
        "validation": {
            "identityProviderRequired": "Identitetsleverandør er påkrevd.",
            "issuerUrlRequired": "Utsteder-URL er påkrevd.",
            "clientIdRequired": "Klient-ID er påkrevd.",
            "clientSecretRequired": "Klienthemmelighet er påkrevd."
        },
        "tooltips": {
            "tokenInfo": "Hvis du mister tokenet ditt, kan det ikke gjenopprettes. Du må i stedet opprette et nytt."
        }
    },
    "buttonType": {
        "PRIMARY": "Primær",
        "SECONDARY": "Sekundær",
        "OUTLINE_PRIMARY": "Primær med omriss",
        "OUTLINE_SECONDARY": "Sekundær med omriss",
        "OUTLINE_DANGER": "Fare med omriss",
        "LINK_PRIMARY": "Primær lenke",
        "LINK_DANGER": "Farelenke"
    },
    "auditLogs": {
        "title": "Revisjonslogger",
        "selectEntity": "Velg enhet",
        "startDate": "Startdato",
        "endDate": "Sluttdato",
        "apply": "Bruk",
        "reset": "Tilbakestill",
        "entity": {
            "users": "Brukere",
            "roles": "Roller",
            "workflows": "Arbeidsflyter",
            "connections": "Tilkoblinger",
            "environments": "Miljøer",
            "application": "Applikasjon",
            "appVersion": "Appversjon",
            "appResource": "Appressurs",
            "roleAssignment": "Rolletildeling",
            "mcpServer": "MCP-server",
            "tenantPrompt": "Tenant-prompt"
        },
        "entityGroup": {
            "platform": "Plattform",
            "aiApps": "AI-apper"
        },
        "table": {
            "userName": "Brukernavn",
            "timeStamp": "Tidsstempel",
            "entity": "Enhet",
            "entityName": "Navn",
            "action": "Handling",
            "details": "Detaljer"
        },
        "expansion": {
            "user": "Bruker:",
            "dateModified": "Endringsdato:",
            "changed": "Endret:",
            "viewChanges": "Vis endringer"
        }
    },
    "filters": {
        "tag": "Tag: {tag}",
        "field": "Felt: {field}",
        "context": "Kontekst: {context}",
        "relativeDates": {
            "0_DAY_START": "Starten av i dag",
            "1_DAY_START": "Starten av i morgen",
            "-1_DAY_START": "Starten av i går",
            "0_WEEK_START": "Starten av denne uken",
            "1_WEEK_START": "Starten av neste uke",
            "-1_WEEK_START": "Starten av forrige uke",
            "0_MONTH_START": "Starten av denne måneden",
            "1_MONTH_START": "Starten av neste måned",
            "-1_MONTH_START": "Starten av forrige måned",
            "0_QUARTER_START": "Starten av dette kvartalet",
            "1_QUARTER_START": "Starten av neste kvartal",
            "-1_QUARTER_START": "Starten av forrige kvartal",
            "0_YEAR_START": "Starten av dette året",
            "1_YEAR_START": "Starten av neste år",
            "-1_YEAR_START": "Starten av forrige år"
        }
    }
}
